<template>
    <div id="login-page">
      <div v-if="currentForm === 'login'" class="login-container">
        <div class="logo-container">
          <img src="https://sander-gruppe.eu/wp-content/uploads/2019/07/ms-logo.png" alt="Ihr Logo" class="logo">
        </div>
        <div class="outer-container">
          <ForgotPassword ref="forgotPasswordComponent" v-show="menuState == 1"/>
          <PasswordChange
            ref="passwordChangeComponent"
            v-show="menuState == 2"
            @password-changed="handlePasswordChanged"
          />
          <div v-show="menuState == 0">
            <h3>m&s Elemente Konfigurator - Login</h3>
            <div v-if="loginError" class="error-message">
                Das Einloggen war nicht möglich. Bitte überprüfen Sie Ihre Eingaben.
            </div>
            <div v-if="blockedError" class="error-message">
                Dieser Benutzer ist blockiert. Bitte wenden Sie sich an den Support.
            </div>
            <div v-if="sessionExpiredMessage" class="error-message">
                {{ sessionExpiredMessage }}
            </div>
            <form @submit.prevent="login">
              <div class="inner-container login-layout">
                <div class="inner-left-container">
                  <div class="input-container">
                    <label for="kdnr">Kundennummer:</label>
                    <input id="kdnr" type="text" v-model="kdnr" required>
                  </div>
                  <div class="input-container">
                    <label for="email">E-Mail:</label>
                    <input id="email" type="email" v-model="email" required>
                  </div>
                  <div class="input-container">
                    <label for="password">Passwort:</label>
                    <div class="password-control-row">
                      <div class="password-wrapper">
                        <input
                          id="password"
                          :type="showPassword ? 'text' : 'password'"
                          v-model="password"
                          required
                        >
                        <button
                          type="button"
                          class="eye-toggle"
                          @click="showPassword = !showPassword"
                          :aria-label="showPassword ? 'Passwort verbergen' : 'Passwort anzeigen'"
                        >
                          <svg v-if="!showPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#747474" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/>
                            <circle cx="12" cy="12" r="3"/>
                          </svg>
                          <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#747474" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 19c-7 0-11-7-11-7a18.45 18.45 0 0 1 5.06-5.94"/>
                            <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 7 11 7a18.5 18.5 0 0 1-2.16 2.88"/>
                            <line x1="1" y1="1" x2="23" y2="23"/>
                            <path d="M14.12 14.12A3 3 0 0 1 9.88 9.88"/>
                            <path d="M9.88 14.12a3 3 0 0 0 4.24 0"/>
                          </svg>
                        </button>
                      </div>
                      <div class="password-side-actions">
                        <button class="primary-login-button" type="submit" :disabled="isLoading">
                          {{ isLoading ? 'Einloggen...' : 'Einloggen' }}
                        </button>
                        <div class="password-action-buttons">
                          <button type="button" @click="changeMenuState(1)">Passwort vergessen</button>
                          <button type="button" @click="changeMenuState(2)">Passwort ändern</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <LegalFooter :show-protected-links="false" :show-feedback-button="false" />
      </div>
      <div v-if="currentForm === 'register'" class="login-container">
        <div class="logo-container">
          <img src="https://sander-gruppe.eu/wp-content/uploads/2019/07/ms-logo.png" alt="Ihr Logo" class="logo">
        </div>
        <div class="outer-container">
          <h3>m&s Elemente Konfigurator - Registrierung</h3>
          <div v-if="registerInfo" class="info-message">
              Die Registrierung war erfolgreich.
          </div>
          <div class="toggle-buttons">
            <button @click="toggleForm('login')">Als Händler einloggen</button>
            <button @click="toggleForm('register')" style="color: #993333;">Neuregistrierung für Händler</button>
          </div>
          <form @submit.prevent="register">
            <div class="inner-container">
              <div class="inner-left-container">
                <div class="input-container">
                  <label for="email">E-Mail:</label>
                  <input id="email" type="email" v-model="email" required>
                </div>
                <div class="input-container">
                  <label for="password">Passwort:</label>
                  <div class="password-wrapper">
                    <input
                      id="password"
                      :type="showPassword ? 'text' : 'password'"
                      v-model="password"
                      required
                    >
                    <button
                      type="button"
                      class="eye-toggle"
                      @click="showPassword = !showPassword"
                      :aria-label="showPassword ? 'Passwort verbergen' : 'Passwort anzeigen'"
                    >
                      <svg v-if="!showPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#747474" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/>
                        <circle cx="12" cy="12" r="3"/>
                      </svg>
                      <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#747474" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 19c-7 0-11-7-11-7a18.45 18.45 0 0 1 5.06-5.94"/>
                        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 7 11 7a18.5 18.5 0 0 1-2.16 2.88"/>
                        <line x1="1" y1="1" x2="23" y2="23"/>
                        <path d="M14.12 14.12A3 3 0 0 1 9.88 9.88"/>
                        <path d="M9.88 14.12a3 3 0 0 0 4.24 0"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div class="inner-right-container">
                <div class="submit-container">
                  <button type="submit">Registrieren</button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <!-- <button @click="deleteAll()">Alle Benutzer löschen</button> -->
        <LegalFooter :show-protected-links="false" />
      </div>
      <div v-if="isLoading" class="loading-overlay">
        <div class="spinner"></div>
      </div>
      <document-acceptance-dialog
        v-if="showDocumentAcceptanceDialog"
        :documents="documentAcceptanceDocuments"
        :privacy-url="documentAcceptancePrivacyUrl"
        :loading="documentAcceptanceLoading"
        :error="documentAcceptanceError"
        @accept="acceptDocumentVersionsAfterLogin"
        @cancel="cancelDocumentAcceptanceAfterLogin"
      />
    </div>
  </template>

  <script>
  import api from '@/api/client';
  import PasswordChange from './FirstUserPassword.vue';
  import ForgotPassword from './ForgotPassword.vue';
  import DocumentAcceptanceDialog from './DocumentAcceptanceDialog.vue';
  import LegalFooter from './LegalFooter.vue';

  export default {
    name: 'LoginPage',
    components: {
        PasswordChange,
        ForgotPassword,
        DocumentAcceptanceDialog,
        LegalFooter
    },
    props: {
      sessionExpiredMessage: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        menuState: 0,
        kdnr: '',
        email: '',
        password: '',
        showPassword: false,
        loginError: false,
        blockedError: false,
        registerInfo: false,
        currentForm: 'login',
        isLoading: false,
        showDocumentAcceptanceDialog: false,
        documentAcceptanceDocuments: [],
        documentAcceptancePrivacyUrl: '',
        documentAcceptanceLoading: false,
        documentAcceptanceError: '',
      };
    },
    methods: {
      toggleForm(formType) {
        this.currentForm = formType;
      },
      async login() {
        if (this.isLoading) {
          return;
        }

        this.$emit('clear-session-expired-message');
        this.loginError = false;
        this.blockedError = false;
        this.documentAcceptanceError = '';
        this.isLoading = true;

        try {
          const response = await api.post('/api/shopusers/login', {
            kdnr: this.kdnr,
            email: this.email,
            password: this.password
          });

          if (response.data?.requires_initial_password_change) {
            this.requireInitialPasswordChange();
            return;
          }

          this.$parent.setLoggedInUser(response.data.user, response.data.token);
          await this.loadCompanyAndContact(response.data.user);

          const canContinue = await this.ensureDocumentAcceptanceAfterLogin();
          if (canContinue) {
            this.continueToDashboard();
          }
        } catch (error) {
          // Fehlerbehandlung
          this.isLoading = false;
          console.error(error);
          if (error.response && error.response.status === 403) {
            this.blockedError = true;
            this.loginError = false;
          } else {
            this.loginError = true;
            this.blockedError = false;
          }
        }
      },
      async loadCompanyAndContact(user) {
        const companyResponse = await api.get(`/api/unternehmen/${user.unternehmen_id}`);
        this.$parent.setCompany(companyResponse.data);

        if (!companyResponse.data?.ansprechpartner_id) {
          this.$parent.setContactPerson(null);
          return;
        }

        try {
          const contactResponse = await api.get(`/api/ansprechpartner/${companyResponse.data.ansprechpartner_id}`);
          this.$parent.setContactPerson(contactResponse.data);
        } catch (error) {
          this.$parent.setContactPerson(null);
          console.error('Fehler beim Laden der Ansprechperson: ', error);
        }
      },
      async ensureDocumentAcceptanceAfterLogin() {
        this.documentAcceptanceLoading = true;
        this.documentAcceptanceError = '';

        try {
          const response = await api.get('/api/document-acceptances/status', {
            params: this.actorParams(),
          });

          if (!response.data?.required) {
            return true;
          }

          this.documentAcceptanceDocuments = this.normalizeDocumentAcceptanceDocuments(response.data.documents || []);
          this.documentAcceptancePrivacyUrl = this.normalizeDocumentUrl(response.data.privacy_policy_url || '');
          this.showDocumentAcceptanceDialog = true;
          return false;
        } catch (error) {
          console.error('Fehler beim Prüfen der Nutzungsbedingungen:', error);
          this.loginError = true;
          return false;
        } finally {
          this.documentAcceptanceLoading = false;
          this.isLoading = false;
        }
      },
      normalizeDocumentAcceptanceDocuments(documents) {
        return documents.map((document) => ({
          ...document,
          pdf_url: this.normalizeDocumentUrl(document.pdf_url || ''),
        }));
      },
      normalizeDocumentUrl(url) {
        const apiBase = String(api.defaults.baseURL || '').replace(/\/$/, '');
        const documentUrl = String(url || '');
        const isAbsoluteUrl = /^https?:\/\//i.test(documentUrl);

        return documentUrl && !isAbsoluteUrl && documentUrl.startsWith('/')
          ? `${apiBase}${documentUrl}`
          : documentUrl;
      },
      async acceptDocumentVersionsAfterLogin(acceptedDocuments) {
        this.documentAcceptanceLoading = true;
        this.documentAcceptanceError = '';

        try {
          await api.post('/api/document-acceptances/accept', {
            accepted_documents: acceptedDocuments,
            ...this.actorParams(),
          });

          this.showDocumentAcceptanceDialog = false;
          this.documentAcceptanceDocuments = [];
          this.documentAcceptancePrivacyUrl = '';
          this.continueToDashboard();
        } catch (error) {
          console.error('Fehler beim Speichern der Nutzungsbedingungen:', error);
          this.documentAcceptanceError = error?.response?.data?.message
            || 'Die Zustimmung konnte nicht gespeichert werden.';
        } finally {
          this.documentAcceptanceLoading = false;
        }
      },
      cancelDocumentAcceptanceAfterLogin() {
        this.showDocumentAcceptanceDialog = false;
        this.documentAcceptancePrivacyUrl = '';
        this.documentAcceptanceError = '';
      },
      continueToDashboard() {
        this.isLoading = false;
        this.loginError = false;
        this.blockedError = false;
        this.$parent.changeMenuState(3);
      },
      requireInitialPasswordChange() {
        this.isLoading = false;
        this.loginError = false;
        this.blockedError = false;
        this.menuState = 2;
        this.$refs.passwordChangeComponent?.startInitialPasswordChange?.({
          kdnr: this.kdnr,
          email: this.email,
          currentPassword: this.password,
        });
      },
      handlePasswordChanged() {
        this.password = '';
        this.changeMenuState(0);
      },
      actorParams() {
        return {};
      },
      register() {
        api.post('/api/shopusers/register', {
          email: this.email,
          password: this.password
        })
        .then(() => {
          // Verarbeiten der Antwort
          this.registerInfo = true;
        })
        .catch(error => {
          // Fehlerbehandlung
          console.error(error);
          this.registerInfo = false;
        });
      },
      deleteAll() {
        api.delete('/api/shopusers/delete-all', {

        })
        .then(response => {
          // Verarbeiten der Antwort
          console.log(response);
        })
        .catch(error => {
          // Fehlerbehandlung
          console.error(error);
        });
      },
      changeMenuState(menuState) {
        this.menuState = menuState;

        if (this.menuState == 1) {
          this.$refs.forgotPasswordComponent?.changeMenuState?.(0);
        }
        else if (this.menuState == 2) {
          this.$refs.passwordChangeComponent?.resetForm?.();
        }

        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    }
  };
  </script>

<style scoped src="@/styles/LoginComponent.css">

</style>
